import angular from 'angular';

import OutsideClickDirective, { selector } from './outside-click.directive';

export default angular
    .module('application.directive.outside-click', [])
    .directive(selector, OutsideClickDirective);



// WEBPACK FOOTER //
// ./src/application/directive/outside-click/index.js